import { StockActionTypes } from './constants';

const STOCK_DATA_INITIAL_STATE = {
    stockData: [],
    loading: false,
};

const stockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.STOCK_DATA_LOADING:
            return {
                stockData: state.stockData,
                loading: true,
            };
        case StockActionTypes.STOCK_DATA_SUCCESS:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STOCK_DATA_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        default:
            return state;
    }
};
const createStockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.CREATE_STOCK_DATA_LOADING:
            return {
                stockData: state.stockData,
                loading: true,
            };
        case StockActionTypes.CREATE_STOCK_DATA_SUCCESS:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.CREATE_STOCK_DATA_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STATE_EMPTY_FIRST:
            return { ...STOCK_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const updateStockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.UPDATE_STOCK_DATA_LOADING:
            return {
                stockData: action.payload,
                loading: true,
            };
        case StockActionTypes.UPDATE_STOCK_DATA_SUCCESS:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.UPDATE_STOCK_DATA_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STATE_EMPTY_FIRST:
            return { ...STOCK_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const deleteStockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.DELETE_STOCK_DATA_LOADING:
            return {
                stockData: action.payload,
                loading: true,
            };
        case StockActionTypes.DELETE_STOCK_DATA_SUCCESS:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.DELETE_STOCK_DATA_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STATE_EMPTY_FIRST:
            return { ...STOCK_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const uploadStockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.UPLOAD_STOCK_DATA_LOADING:
            return {
                stockData: state.stockData,
                loading: true,
            };
        case StockActionTypes.UPLOAD_STOCK_DATA_SUCCESS:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.UPLOAD_STOCK_DATA_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STATE_EMPTY_FIRST:
            return { ...STOCK_DATA_INITIAL_STATE };
        default:
            return state;
    }
};
const getTagInStockDataReducer = (state = STOCK_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case StockActionTypes.FIND_TAG_IN_STOCK_LOADING:
            return {
                stockData: state.stockData,
                loading: true,
            };
        case StockActionTypes.FIND_TAG_IN_STOCK_ERROR:
            return {
                stockData: action.payload,
                loading: false,
            };
        case StockActionTypes.STATE_EMPTY_FIRST:
            return { ...STOCK_DATA_INITIAL_STATE };
        default:
            return state;
    }
};

export { stockDataReducer, createStockDataReducer, updateStockDataReducer, deleteStockDataReducer, uploadStockDataReducer, getTagInStockDataReducer };
